import moment from 'moment-business-days';
import firebase from 'firebase/app';

export const calculaHorasExtras = (minutos, horasSemana, data) => {
  const diasUteis = data.monthBusinessDays();
  let nDiasUteisAteHoje;
  if (data.month() === moment().month()) nDiasUteisAteHoje = diasUteis.findIndex(dia => dia.dayOfYear() === data.dayOfYear()) + 1;
  else nDiasUteisAteHoje = diasUteis.length;
  const minutosSemana = horasSemana / 5 * 60;
  return minutos - (nDiasUteisAteHoje * minutosSemana);
};

export const calculaHorasMes = data => new Promise(resolve => {
  const ref = firebase.database().ref('horarios');
  ref.on('value', snap => {
    const hist_horas = [];
    const uid = Object.keys(snap.val());
    const horarios = Object.values(snap.val());
    const ano = data.year();
    const mes = data.format('MM');

    horarios.forEach((element, index) => {
      let colaborador = '';
      let soma_minutos = 0;
      if (element[ano]) if (element[ano][mes]) {
        Object.values(element[ano][mes]).forEach(dia => {
          const dia_arr = Object.values(dia);
          for (let i = 0; i < dia_arr.length; i += 1) {
            colaborador = dia_arr[i].colaborador;
            if (dia_arr[i].tipo === 'saindo') {
              const df = moment(dia_arr[i].data);
              const di = moment(dia_arr[i - 1].data);
              soma_minutos += df.diff(di, 'minutes');
            } else if (dia_arr[i].tipo === 'justificativa') soma_minutos += dia_arr[i].minutos;
          }
        });
        const refColaborador = firebase.database().ref(`colaboradores/${uid[index]}`);
        refColaborador.once('value', colab => {
          const minutos_extras = calculaHorasExtras(soma_minutos, colab.val().horasSemana, data);
          hist_horas.push({
            uid: uid[index],
            minutos: soma_minutos,
            colaborador: colaborador,
            minutos_extras: minutos_extras,
            horas_extras: `${parseInt(minutos_extras / 60, 10)}h ${(`0${minutos_extras % 60}`).replace(/-/g, '').slice(-2)}m`.replace(/-/g, '')
          });
        });
      }
    });
    setTimeout(() => {
      hist_horas.sort((a, b) => {
        if (a.colaborador > b.colaborador) return 1;
        if (a.colaborador < b.colaborador) return -1;
        return 0;
      });
      resolve(hist_horas);
    }, 200);
  });
});

export const calculaHorasMesColaborador = (data, uid, horasSemana) => new Promise(resolve => {
  const ano = data.year();
  const mes = data.format('MM');
  const ref = firebase.database().ref(`horarios/${uid}/${ano}/${mes}`);
  ref.on('value', snap => {
    if (snap.exists()) {
      let soma_minutos = 0;
      const dias = Object.values(snap.val());
      dias.forEach(dia => {
        const dia_arr = Object.values(dia);
        for (let i = 0; i < dia_arr.length; i += 1) if (dia_arr[i].tipo === 'saindo') {
          const df = moment(dia_arr[i].data);
          const di = moment(dia_arr[i - 1].data);
          soma_minutos += df.diff(di, 'minutes');
        } else if (dia_arr[i].tipo === 'justificativa') soma_minutos += dia_arr[i].minutos;
      });
      const minutos_extras = calculaHorasExtras(soma_minutos, horasSemana, data);
      const horas_mes = {
        minutos: soma_minutos,
        minutos_extras: minutos_extras,
        horas_extras: `${parseInt(minutos_extras / 60, 10)}h ${(`0${minutos_extras % 60}`).replace(/-/g, '').slice(-2)}m`.replace(/-/g, '')
      };
      resolve(horas_mes);
    } else resolve(null);
  });
});

export const calculaHorasMesesColaborador = (data, uid, horasSemana) => new Promise(resolve => {
  const ano = data.year();
  const ref = firebase.database().ref(`horarios/${uid}/${ano}`);
  ref.on('value', snap => {
    if (snap.exists()) {
      const horas_mes = [];
      const meses = Object.entries(snap.val());
      meses.forEach(dias => {
        const mes = (dias[0] === data.format('MM')) ? data : moment(`${dias[0]}/${ano}`, 'MM/YYYY');
        let soma_minutos = 0;
        const dias_arr = Object.values(dias[1]);
        dias_arr.forEach(dia => {
          const dia_arr = Object.values(dia);
          for (let i = 0; i < dia_arr.length; i += 1) if (dia_arr[i].tipo === 'saindo') {
            const df = moment(dia_arr[i].data);
            const di = moment(dia_arr[i - 1].data);
            soma_minutos += df.diff(di, 'minutes');
          } else if (dia_arr[i].tipo === 'justificativa') soma_minutos += dia_arr[i].minutos;
        });
        const minutos_extras = calculaHorasExtras(soma_minutos, horasSemana, mes);
        horas_mes.push({
          mes: mes,
          minutos: soma_minutos,
          horas: `${parseInt(soma_minutos / 60, 10)}h ${(`0${soma_minutos % 60}`).replace(/-/g, '').slice(-2)}m`,
          minutos_extras: minutos_extras,
          horas_extras: `${parseInt(minutos_extras / 60, 10)}h ${(`0${minutos_extras % 60}`).replace(/-/g, '').slice(-2)}m`.replace(/-/g, '')
        });
      });
      horas_mes.sort((a, b) => {
        if (a.mes.format('MM') > b.mes.format('MM')) return 1;
        if (a.mes.format('MM') < b.mes.format('MM')) return -1;
        return 0;
      });
      resolve(horas_mes.reverse());
    } else resolve(null);
  });
});
